import { useQuery } from 'react-query';
import { MaestroAPI, maestroApiCall } from '@michelin/central-provider';
import { baseURL } from 'Types/APITypes';

const getService = (stNumber: string | null) => {
  if (!stNumber) return null;
  return maestroApiCall({ method: 'GET', endpoint: `locations/${stNumber}/retail-services`, baseURL }).then((data) => {
    if (data?.retail_services) {
      const { retail_services } = data;
      Object.entries(retail_services).forEach(([key, value]) => {
        if (value === null) retail_services[key] = false;
      });
    }
    return data.retail_services;
  });
};

export default function useService(stNumber: string | null) {
  return useQuery(['service', stNumber], () => getService(stNumber));
}

interface saveParams {
  stNumber: string,
  data: any
}

export async function saveServices({ stNumber, data }: saveParams) {
  const apiType: MaestroAPI = { method: 'PUT', endpoint: `locations/${stNumber}/retail-services`, baseURL };

  if (data?.services) {
    const { services } = data;
    Object.entries(services).forEach(([key, value]) => {
      if (key === 'tire_warranty') {
        if (!value) services.protections_and_warranties[key] = '';
        return;
      }
      if (value === null || value === undefined) services[key] = false;
    });
  }

  const response = await maestroApiCall(apiType, data).then((res) => res.data);
  return response;
}
